import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PageGuard, PageType } from 'src/app/core/services/page-guard.service';
import { ContentPageComponent } from './content-page.component';

const routes: Routes = [
    {
        path: '',
        component: ContentPageComponent,
        canActivate: [PageGuard],
        data: { Page: PageType.Catalog }
    }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ContentPageRoutingModule { }
